import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'deviceinfo',
  data: function data() {
    return {
      battery: 30,
      did: '111',
      SN: '22222'
    };
  },
  components: {},
  methods: {
    getImageSrc: function getImageSrc(value) {
      if (value >= 0 && value <= 10) {
        return require('@/assets/images/lowD.png');
      } else if (value >= 11 && value <= 30) {
        return require('@/assets/images/centerD.png');
      } else if (value >= 31 && value <= 60) {
        return require('@/assets/images/heightD.png');
      } else if (value >= 61 && value <= 100) {
        return require('@/assets/images/fullD.png');
      }

      return ''; // 默认值
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this = this;

      navigator.clipboard.writeText(text).then(function () {
        // alert('已复制: ' + text);
        _this.$Message.success(_this.$t('复制成功'));
      }).catch(function (err) {
        console.error('复制失败:', err);
      });
    }
  }
};